import { render } from "./Checkbox.vue?vue&type=template&id=d3b6bd4a"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Fields/Checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3b6bd4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3b6bd4a', __exports__)) {
    api.reload('d3b6bd4a', __exports__)
  }
  
  module.hot.accept("./Checkbox.vue?vue&type=template&id=d3b6bd4a", () => {
    api.rerender('d3b6bd4a', render)
  })

}


export default __exports__